var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "title_h1" }, [_vm._v("見積書等提出")]),
      _c(
        "vab-collapse-info",
        [
          _c("template", { slot: "title" }, [
            _vm._v(
              " " +
                _vm._s(_vm.getFieldValue("demandBaseIdModel.title", _vm.info)) +
                "［" +
                _vm._s(_vm.getFieldValue("acceptOrderNo", _vm.info)) +
                "］ "
            ),
          ]),
          _vm.showDownLoad
            ? _c("template", { slot: "upload" }, [
                _c(
                  "div",
                  {
                    staticClass: "flex_center_align",
                    on: {
                      click: function ($event) {
                        return _vm.downLoadInfomation(
                          "/api/scheduleAdjAnswer/partner/estimate/download"
                        )
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v("見積情報ダウンロード")]),
                    _c("svg-icon", {
                      staticClass: "upload_svg",
                      attrs: { "icon-class": "download_2_line" },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c(
            "template",
            { slot: "row" },
            [
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("建物")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 20 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "buildingCdModel.blgsnmkj",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("商品")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "demandBaseIdModel.itemCdModel.itmnm",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("商品明細")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box center_box", attrs: { span: 8 } },
                    _vm._l(_vm.mitmdtlpModelList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "flex_space width_100" },
                        [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getFieldValue("itmdtlnm", item)) +
                                " "
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("依頼件名")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 20 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "requestIdModel.constructionName",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("案件分類")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnumText(
                              _vm.getFieldValue(
                                "demandBaseIdModel.businessForm",
                                _vm.info
                              ),
                              _vm.$divisions.consignmentWorkClassEnum
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("依頼区分")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnumText(
                              _vm.getFieldValue(
                                "requestIdModel.requestClass",
                                _vm.info
                              ),
                              _vm.$divisions.requestClassEnum
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("進行部門")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "demandBaseIdModel.progressDepCdModel.orgkjrn",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("進行担当者")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box center_box", attrs: { span: 8 } },
                    _vm._l(
                      _vm.getFieldValue(
                        "demandBaseIdModel.demandChargePersonModelList",
                        _vm.info
                      ),
                      function (item, index) {
                        return _c("div", { key: index }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getFieldValue(
                                  "empnmkj",
                                  item.chargePersonCdModel
                                )
                              ) +
                              " "
                          ),
                        ])
                      }
                    ),
                    0
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("書類提出期限")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "requestIdModel.docLimitDate",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("書類状況")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnumText(
                              _vm.getFieldValue("docSubmitStatus", _vm.info),
                              _vm.$divisions.docSubmitStatusEnum
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("工事内容")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 20 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "requestIdModel.constructionDetail",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "info_main" },
        [
          _c(
            "vab-form",
            { ref: "form", attrs: { model: _vm.form } },
            [
              _c("vab-file", { ref: "vabFile" }, [
                _c("div", { attrs: { slot: "hd_title" }, slot: "hd_title" }, [
                  _vm._v("書類提出"),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "sure_box" },
                [
                  _c(
                    "vab-row",
                    { staticClass: "row_box" },
                    [
                      _c(
                        "vab-col",
                        { staticClass: "title_box", attrs: { span: 4 } },
                        [_vm._v("協力会社コメント")]
                      ),
                      _c(
                        "vab-col",
                        {
                          staticClass: "word_box nopadding2 pdtb8",
                          attrs: { span: 20 },
                        },
                        [
                          _c("vab-textarea", {
                            attrs: {
                              type: "textarea",
                              prop: "docComment",
                              rows: "5",
                              maxlength: "2340",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("vab-message", {
                    ref: "vabMessage",
                    staticClass: "noborder",
                    attrs: {
                      title: "コメント履歴を閉じる",
                      "msg-type":
                        _vm.$divisions.adjSourceClassEnum.enum_1.value,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex_end mg12" },
            [_c("vab-button", { attrs: { "btn-list": _vm.btnList } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }